module.exports = __webpack_public_path__ + "static/logo-12a363816ccdc26ef32945daaf952b3c.svg";